import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from '@material-ui/core/Button';

export const ModalOKCancel = (props) => (
    <Modal backdrop="static" show={props.show} >
        <Modal.Header>
            <Modal.Title style={{ textAlign: 'center' }}>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: 'center' }}>{props.body}</Modal.Body>
        <Modal.Footer style={{ textAlign: 'right' }}>
            <Button variant='contained' color='default' style={{ marginRight: '15px', minWidth: '80px' }} onClick={props.onCancel}>Cancel</Button>
            <Button variant='contained' color='primary' style={{ minWidth: '80px' }} onClick={props.onOK} >{props.okText === undefined ? "OK" : props.okText}</Button>
        </Modal.Footer>
    </Modal>
)



// WEBPACK FOOTER //
// ./src/modals.js